import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { Email } from '../email';

@Injectable({
    providedIn: 'root'
})
export class EmailHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = configServerService.getPathApiEmail();
    }

    /** Envia um e-mail */
    send(email: Email): Observable<string> {
        return this.customHttp.post<string>(this.pathApi, email);
    }
}
